import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { UserRole } from '@/types/user.types'

interface RoleState {
  activeRole: UserRole
}

interface RoleActions {
  setRole: (role: UserRole) => void
  syncRoles: (roles: UserRole[]) => void
}

function chooseRole(current: UserRole, roles: UserRole[]): UserRole {
  if (roles.length === 0) return 'attendee'
  return roles.includes(current) ? current : roles[0]
}

export const useRoleStore = create<RoleState & RoleActions>()(
  persist(
    (set, get) => ({
      activeRole: 'attendee',
      setRole: (role) => set({ activeRole: role }),
      syncRoles: (roles) => set({ activeRole: chooseRole(get().activeRole, roles) }),
    }),
    { name: 'kaat-role' },
  ),
)
